import { api } from './api';
import { GrupoGuia, CreateGrupoGuiaDTO, UpdateGrupoGuiaDTO, GrupoGuiaStats } from '../types/grupos';

export interface ListGrupoGuiasParams {
  categoria?: string;
  status?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export interface ListGrupoGuiasResponse {
  guias: GrupoGuia[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const grupoGuiasService = {
  // Listar guias de um grupo
  async listar(grupoId: string, params?: ListGrupoGuiasParams): Promise<ListGrupoGuiasResponse> {
    const response = await api.get(`/grupos/${grupoId}/guias`, { params });
    return response.data;
  },

  // Buscar uma guia específica
  async buscarPorId(guiaId: string, incrementarVisualizacao = false): Promise<GrupoGuia> {
    const response = await api.get(`/grupos/guias/${guiaId}`, {
      params: { incrementar_visualizacao: incrementarVisualizacao }
    });
    return response.data;
  },

  // Criar nova guia
  async criar(grupoId: string, data: CreateGrupoGuiaDTO): Promise<GrupoGuia> {
    const response = await api.post(`/grupos/${grupoId}/guias`, data);
    return response.data;
  },

  // Atualizar guia
  async atualizar(guiaId: string, data: UpdateGrupoGuiaDTO): Promise<GrupoGuia> {
    const response = await api.put(`/grupos/guias/${guiaId}`, data);
    return response.data;
  },

  // Excluir guia
  async excluir(guiaId: string): Promise<void> {
    await api.delete(`/grupos/guias/${guiaId}`);
  },

  // Reordenar guias
  async reordenar(grupoId: string, guiaIds: string[]): Promise<void> {
    await api.put(`/grupos/${grupoId}/guias/reorder`, { guiaIds });
  },

  // Obter estatísticas
  async obterEstatisticas(grupoId: string): Promise<GrupoGuiaStats> {
    const response = await api.get(`/grupos/${grupoId}/guias/stats`);
    return response.data;
  },

  // Obter categorias
  async obterCategorias(grupoId: string): Promise<string[]> {
    const response = await api.get(`/grupos/${grupoId}/guias/categorias`);
    return response.data;
  }
};
